import { ClearanceItemService } from '../clearance-item/clearance-item.service';
import { NgModule } from '@angular/core';
import { SearchComponent } from './search.component';
import { CommonModule } from '@angular/common';
import { SearchService } from './search.service';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../shared/core/auth.service';
// import { ClearanceItemBulkComponent } from '../clearance-item/bulk-action/clearance-item-bulk.component';
import { ClearanceItemGroupNameComponent } from '../clearance-item/clearance-item-groupname.component';
import { ClearanceItemBulkBarComponent } from '../clearance-item/bulk-action/clearance-item-bulkbar.component';
import { AssetManagerModule } from '../shared/asset-manager.module';
import { ClearanceItemBulkModule } from '../clearance-item/bulk-action/clearance-item-bulk.module';
import { ClearanceItemCommonModule } from '../clearance-item/clearance-item-common.module';
@NgModule({
    declarations: [
        SearchComponent
    ],
    imports: [
        CommonModule, 
        ReactiveFormsModule, 
        SharedModule,
        AssetManagerModule,
        ClearanceItemBulkModule,
        ClearanceItemCommonModule
    ],
    providers: [
        SearchService, 
        // ClearanceItemService, 
        AuthService]
})
export class SearchModule {

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/search/search.module.ts